import { FC, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ListItem, ListItemIcon, ListItemText, Tooltip, Button, useMediaQuery, useTheme } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BarChartIcon from '@material-ui/icons/BarChart';
import PeopleIcon from '@material-ui/icons/People';
import LayersIcon from '@material-ui/icons/Layers';
import SettingsIcon from '@material-ui/icons/Settings';
//import Brightness5Icon from '@material-ui/icons/Brightness5';
//import PostAddIcon from '@material-ui/icons/PostAdd';
//import CategoryIcon from '@material-ui/icons/Category';
import BusinessIcon from '@material-ui/icons/Business';
//import HowToRegIcon from '@material-ui/icons/HowToReg';
// import PaymentIcon from '@material-ui/icons/Payment';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Divider from '@material-ui/core/Divider';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
//import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
//import { ProdLDAP } from 'components/ProdLDAP';
import { useStyles } from '../styles';
import clsx from 'clsx';
import { useStore } from 'hooks/useRootStore';
import { MenuItem } from './types';
import { observer } from 'mobx-react-lite';
import { handleCompanyUrl } from 'utils/organizationUtils';
import ClientProgress from 'containers/ClientProgress/ClientProgress';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import AppsIcon from '@material-ui/icons/Apps';
import DevicesIcon from '@material-ui/icons/Devices';

export const MainItems: FC = observer(() => {
  const [openDataSourcePopup, setOpenDataSourcePopup] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    appMenuStore: { isOpen, closeAppMenu },
    userStore: { user },
  } = useStore();

  const handleItemClick = (path: string) => {
    if (path) {
      history.push(path);
      if (isMobile) {
        closeAppMenu();
      }
    }
  };

  // const handleGettingStartedClick = () => {
  //   setOpenDataSourcePopup(true);
  // };

  const itemsMock: MenuItem[] = [
    {
      path: handleCompanyUrl('/dashboard'),
      label: 'Dashboard',
      icon: <DashboardIcon />,
    },
    {
      path: handleCompanyUrl('/users'),
      label: 'Users',
      icon: <PeopleIcon />,
    },
    {
      path: handleCompanyUrl('/groups'),
      label: 'Groups',
      icon: <LayersIcon />,
    },
    {
      path: handleCompanyUrl('/departments'),
      label: 'Departments',
      icon: <BusinessIcon />,
    },
    {
      path: handleCompanyUrl('/apps'),
      label: 'Provision Apps',
      icon: <AppsIcon />,
    },
    {
      path: handleCompanyUrl('/devices'),
      label: 'Devices',
      icon: <DevicesIcon />,
    },
    {
      path: handleCompanyUrl('/admins'),
      label: 'Admin Team',
      icon: <SupervisedUserCircleIcon />,
    },
    // {
    //   path: handleCompanyUrl('/payments'),
    //   label: 'Payments',
    //   icon: <PaymentIcon />,
    // },
    {
      path: handleCompanyUrl('/reports'),
      label: 'Security Insights',
      icon: <BarChartIcon />,
    },
    {
      path: handleCompanyUrl('/admin/users-edit-request'),
      label: 'Requests',
      icon: <RecordVoiceOverIcon />,
    },
    {
      path: handleCompanyUrl('/import'),
      label: 'Upload',
      icon: <CloudUploadIcon />,
    },
    {
      path: handleCompanyUrl('/settings'),
      label: 'Settings',
      icon: <SettingsIcon />,
    },
  ];
  const itemsEndUser: MenuItem[] = [
    {
      path: handleCompanyUrl('/admin/dashboard'),
      label: 'Dashboard',
      icon: <DashboardIcon />,
    },
    {
      path: handleCompanyUrl('/admin/profile'),
      label: 'Profile',
      icon: <PeopleIcon />,
    },
    {
      path: handleCompanyUrl('/groups'),
      label: 'Groups',
      icon: <LayersIcon />,
    },
    {
      path: handleCompanyUrl('/departments'),
      label: 'Departments',
      icon: <BusinessIcon />,
    },
    {
      path: handleCompanyUrl('/apps'),
      label: 'Apps',
      icon: <AppsIcon />,
    },
    {
      path: handleCompanyUrl('/devices'),
      label: 'Devices',
      icon: <DevicesIcon />,
    },
    {
      path: handleCompanyUrl('/end-user/request'),
      label: 'Requests',
      icon: <RecordVoiceOverIcon />,
    },
    {
      path: handleCompanyUrl('/reports'),
      label: 'Security Insights',
      icon: <BarChartIcon />,
    },
    {
      path: handleCompanyUrl('/settings'),
      label: 'Settings',
      icon: <SettingsIcon />,
    },
  ];
  const itemsManagerUser: MenuItem[] = [
    {
      path: handleCompanyUrl('/admin/dashboard'),
      label: 'Dashboard',
      icon: <DashboardIcon />,
    },
    {
      path: handleCompanyUrl('/admin/profile'),
      label: 'Profile',
      icon: <PeopleIcon />,
    },
    {
      path: handleCompanyUrl('/groups'),
      label: 'Groups',
      icon: <LayersIcon />,
    },
    {
      path: handleCompanyUrl('/departments'),
      label: 'Departments',
      icon: <BusinessIcon />,
    },
    {
      path: handleCompanyUrl('/apps'),
      label: 'Apps',
      icon: <AppsIcon />,
    },
    {
      path: handleCompanyUrl('/devices'),
      label: 'Devices',
      icon: <DevicesIcon />,
    },
    {
      path: handleCompanyUrl('/admin/users-edit-request'),
      label: 'Requests',
      icon: <RecordVoiceOverIcon />,
    },
    {
      path: handleCompanyUrl('/reports'),
      label: 'Security Insights',
      icon: <BarChartIcon />,
    },
    //     {
    //   path: handleCompanyUrl('/settings'),
    //   label: 'Settings',
    //   icon: <SettingsIcon />,
    // },
  ];

  return (
    <>
      {user && user.permission !== 'EndUser' ? (
        <>
          {user.permission === 'SystemAdmin' && (
            <>
              {itemsMock
                .filter((item) => item.label !== 'Payments')
                .map((item, index) => {
                  const listItem = (
                    <span key={`${item.path}_${item.label}_${index}`}>
                      <ListItem
                        button
                        className={clsx(
                          item.path === location.pathname ? classes.activeListItem : '',
                          classes.mobileListItem
                        )}
                        onClick={() => handleItemClick(item.path)}
                      >
                        <ListItemIcon
                          classes={{
                            root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                              [classes.activeListItemIcon]: item.path === location.pathname,
                            }),
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.label} className={classes.listTextStyling} />
                      </ListItem>
                      {item.label === 'Dashboard' ? <Divider /> : null}
                      {item.label === 'Departments' ? <Divider /> : null}
                    </span>
                  );
                  return isOpen ? (
                    listItem
                  ) : (
                    <Tooltip title={item.label} placement='bottom'>
                      {listItem}
                    </Tooltip>
                  );
                })}
            </>
          )}
          {user.permission === 'billing_admin' && (
            <>
              {itemsMock
                .filter((item) => item.label === 'Payments' || item.label === 'Dashboard')
                .map((item, index) => {
                  const listItem = (
                    <span key={`${item.path}_${item.label}_${index}`}>
                      <ListItem
                        button
                        className={clsx(
                          item.path === location.pathname ? classes.activeListItem : '',
                          classes.mobileListItem
                        )}
                        onClick={() => handleItemClick(item.path)}
                      >
                        <ListItemIcon
                          classes={{
                            root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                              [classes.activeListItemIcon]: item.path === location.pathname,
                            }),
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.label} className={classes.listTextStyling} />
                      </ListItem>
                      {item.label === 'Dashboard' ? <Divider /> : null}
                      {item.label === 'Departments' ? <Divider /> : null}
                    </span>
                  );
                  return isOpen ? (
                    listItem
                  ) : (
                    <Tooltip title={item.label} placement='bottom'>
                      {listItem}
                    </Tooltip>
                  );
                })}
            </>
          )}
          {user.permission === 'UserAdmin' && (
            <>
              {itemsMock
                .filter(
                  (item) =>
                    item.label === 'Users' ||
                    item.label === 'Groups' ||
                    item.label === 'Departments' ||
                    item.label === 'Requests'
                )
                .map((item, index) => {
                  const listItem = (
                    <span key={`${item.path}_${item.label}_${index}`}>
                      <ListItem
                        button
                        className={clsx(
                          item.path === location.pathname ? classes.activeListItem : '',
                          classes.mobileListItem
                        )}
                        onClick={() => handleItemClick(item.path)}
                      >
                        <ListItemIcon
                          classes={{
                            root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                              [classes.activeListItemIcon]: item.path === location.pathname,
                            }),
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.label} className={classes.listTextStyling} />
                      </ListItem>
                      {item.label === 'Dashboard' ? <Divider /> : null}
                      {item.label === 'Departments' ? <Divider /> : null}
                    </span>
                  );
                  return isOpen ? (
                    listItem
                  ) : (
                    <Tooltip title={item.label} placement='bottom'>
                      {listItem}
                    </Tooltip>
                  );
                })}
            </>
          )}
          {user.permission === 'ClientAdmin' && (
            <>
              <div style={isMobile ? { padding: '0 8px' } : {}}>
                <Button
                  variant='contained'
                  color='secondary'
                  style={isMobile ? { margin: '8px 0', width: '100%', fontSize: '12px' } : { margin: '10px' }}
                  onClick={() => history.push(handleCompanyUrl('/reports'))}
                >
                  Risk Scanner
                  <WavingHandIcon style={{ color: '#ffc107' }} />
                </Button>
              </div>
              {openDataSourcePopup && (
                <ClientProgress
                  open={openDataSourcePopup}
                  handleClose={() => {
                    setOpenDataSourcePopup(false);
                  }}
                />
              )}
              {itemsMock.map((item, index) => {
                const listItem = (
                  <span key={`${item.path}_${item.label}_${index}`}>
                    <ListItem
                      button
                      className={clsx(
                        item.path === location.pathname ? classes.activeListItem : '',
                        classes.mobileListItem
                      )}
                      onClick={() => handleItemClick(item.path)}
                      style={item.label === 'Settings' ? { margin: '10px 0px' } : {}}
                    >
                      <ListItemIcon
                        classes={{
                          root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                            [classes.activeListItemIcon]: item.path === location.pathname,
                          }),
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.label} className={classes.listTextStyling} />
                    </ListItem>
                    {item.label === 'Dashboard' ? <Divider /> : null}
                    {item.label === 'Departments' ? <Divider /> : null}
                    {item.label === 'Upload' ? <Divider /> : null}
                  </span>
                );
                return isOpen ? (
                  listItem
                ) : (
                  <Tooltip title={item.label} placement='bottom'>
                    {listItem}
                  </Tooltip>
                );
              })}
            </>
          )}
          {user.permission === 'Manager' && (
            <>
              {itemsManagerUser.map((item, index) => {
                const listItem = (
                  <span key={`${item.path}_${item.label}_${index}`}>
                    <ListItem
                      button
                      className={clsx(
                        item.path === location.pathname ? classes.activeListItem : '',
                        classes.mobileListItem
                      )}
                      onClick={() => handleItemClick(item.path)}
                    >
                      <ListItemIcon
                        classes={{
                          root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                            [classes.activeListItemIcon]: item.path === location.pathname,
                          }),
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText primary={item.label} className={classes.listTextStyling} />
                    </ListItem>
                    {item.label === 'Departments' ? <Divider /> : null}
                  </span>
                );
                return isOpen ? (
                  listItem
                ) : (
                  <Tooltip title={item.label} placement='bottom'>
                    {listItem}
                  </Tooltip>
                );
              })}
            </>
          )}
        </>
      ) : (
        itemsEndUser.map((item, index) => {
          const listItem = (
            <span key={`${item.path}_${item.label}_${index}`}>
              <ListItem
                button
                className={clsx(item.path === location.pathname ? classes.activeListItem : '', classes.mobileListItem)}
                onClick={() => handleItemClick(item.path)}
              >
                <ListItemIcon
                  classes={{
                    root: clsx(classes.listItemIcon, classes.mobileListItemIcon, {
                      [classes.activeListItemIcon]: item.path === location.pathname,
                    }),
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.label} className={classes.listTextStyling} />
              </ListItem>
              {item.label === 'Departments' ? <Divider /> : null}
            </span>
          );
          return isOpen ? (
            listItem
          ) : (
            <Tooltip title={item.label} placement='bottom'>
              {listItem}
            </Tooltip>
          );
        })
      )}
    </>
  );
});
